import { IReturn } from "@/interfaces/Return";
import React from "react";

interface ReturnHeaderProps {
  return_: IReturn;
}

const ReturnHeader: React.FC<ReturnHeaderProps> = ({ return_ }) => {
  return (
    <div className="px-4 py-4 flex items-start justify-between gap-2 flex-row ">
      <div className="space-y-1">
        <p className="text-md text-muted-foreground">N° de retour</p>
        <p className="font-semibold">
          {return_.numTournee && return_.numTournee}
        </p>
      </div>
      <div className="space-y-1 text-right">
        <p className="text-md text-muted-foreground">Vendeur</p>
        <p className="font-semibold">
          {return_.sellerName && return_.sellerName}
        </p>
      </div>
    </div>
  );
};

export default ReturnHeader;
